import React from 'react';
import {
  apiCallBegan,
  APICallMethods
} from '@gjensidige/se-redux-api-middleware';

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { useDeviceWidth } from '../hooks/useDeviceWidth';
import APP_CONSTANTS, { API_OPERATIONS, PRODUCTS } from '../lib/constants/appConstants';
import API_ENDPOINTS from '../lib/constants/endpoints';
import { updateEnquirySelection } from '../store/slices/offerSlice';
import {
  onApiError,
  onApiSuccess,
  updateLoadingStatus
} from '../store/slices/offerSlice';
import { Enquiry } from '../components/Enquiry/Enquiry';
import {
  IPricingQuestion,
  IPricingStepConfig
} from '../interfaces/EnquiryInterface';
import { APIHelper } from '../utils/ApiHelper';

interface IEnquiryContainerProps {
  stepCode: string;
  isVerticalGroup?: boolean;
  wrapperClassName?: string;
}

export const EnquiryContainer: React.FC<IEnquiryContainerProps> = (
  props: IEnquiryContainerProps
) => {
  const offerDetails = useAppSelector((state) => state.insurance.offer);
  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );

  const dispatch = useAppDispatch();
  const { isLargeScreen } = useDeviceWidth();

  const stepQuestions = useAppSelector((state) =>
    state.insurance.pricingQuestions.find(
      (item: IPricingStepConfig) => item.stepCode === props.stepCode
    )
  );
  const handleChange = (type: string, value: string, isValid?: boolean, checked?: boolean) => {
    updateSelection(type, value, isValid, checked);
    if(shouldCallUpdateInsurance(type)) {
      updateInsurance(type, value);
   }
  };

  const updateSelection = (type: string, value: string, isValid?: boolean, checked?: boolean) => {
    dispatch(
      updateEnquirySelection({
        questionType: type,
        selectedOption: value,
        stepCode: props.stepCode,
        isValid: !!isValid,
        isChecked: !!checked
      })
    );
  };

  const shouldCallUpdateInsurance = (key: string) => {
    return productName !== PRODUCTS.PPI || (key !== 'workAbility' && key !== 'swedenResidence');
  };

  const updateInsurance = async (key: string, value: string) => {
    const updateInsurancePayload = APIHelper.buildUpdateOfferRequest(
      productName,
      offerDetails,
      key,
      value
    );
    dispatch(updateLoadingStatus('updating'));
    dispatch(
      apiCallBegan({
        init: {
          headers: {
            Applikasjon: APP_CONSTANTS.application
          },
          body: {
            ...updateInsurancePayload
          }
        },
        url: API_ENDPOINTS.updateOfferURL,
        apiOperation: API_OPERATIONS.UPDATE_INSURANACE_OFFER,
        method: APICallMethods.POST_JSON,
        onStart: '',
        onSuccess: onApiSuccess.type,
        onError: onApiError.type
      })
    );
  };

  const shouldCenterAligned = () => {
    return isLargeScreen && props.stepCode === '001';
  };

  return (
    <div className={`${stepQuestions?.isolatedSection ? '' : `enquiry-container ${props.wrapperClassName || ''}`}`}>
    {stepQuestions?.questions?.map((item: IPricingQuestion, index: number) => 
      item.isVisible && (          
          <div key={index} className={`${stepQuestions?.isolatedSection ? 'mt-3 isolated-section-wrapper' : ''}`}>
            <Enquiry
              data={item}
              handleChange={handleChange}
              alignCenter={false}
              stepCode={props.stepCode}
              isVertical={props.isVerticalGroup}
              isMarginTop={stepQuestions?.noMargin}
            />
          </div>
      )
     )}
    </div>
  );
};
